import React, { useEffect } from "react";
import axios from "axios";
function TrackVisitLogger() {
  useEffect(() => {
    axios
      .get(`https://luckyduckgroup.com/Admin/track-visit`) // replace with your actual API URL
      .catch((error) => {
        console.error("Error logging visitor data:", error);
      });
  }, []);

  return null; // no UI
}

export default TrackVisitLogger;
